import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { UtentiService } from '../../../services/utenti.service';
import { JossoService } from '../../../services/josso.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';

@Component({
	selector: 'app-loader-full',
	templateUrl: './loader-full.component.html',
	styleUrls: ['./loader-full.component.css']
})
export class LoaderFullComponent {
	jossoChecker: any;
	jossoChecks: number;
	jossoCheckEnded: string;

	constructor(
		private utentiService: UtentiService,
		private authService: AuthService,
		private jossoService: JossoService,
		private router: Router,
		private cookieService: CookieService
  	) { }

	ngOnInit() {
		if(this.authService.authToken){
			if(this.utentiService.getUser()){
				console.log("CMP|LOADER-FULL - authToken si user navigate ", this.authService.lastVisited);
				this.router.navigate([this.authService.lastVisited]);
			}else{
				console.log("CMP|LOADER-FULL - authToken no user");
			}
		}else if(this.cookieService.get('josso_username')){
			setTimeout(
				() => {	this.jossoService.getSessionCookie(); }, 0
			);
		}else if(this.cookieService.get('JOSSO_SESSIONID')){
			console.log("CMP|LOADER-FULL - no authToken JOSSO_SESSIONID navigate", this.authService.lastVisited);
			this.router.navigate([this.authService.lastVisited]);
		}else if(!this.jossoService.sendingCheck){
			console.log("CMP|LOADER-FULL - no authToken !jossoService.sendingCheck navigate login");
			this.router.navigate(['/login']);
		}else{
			console.log("CMP|LOADER-FULL - no authToken jossoService.sendingCheck");
		}
	}
}
